import { Form, Formik } from 'formik'
import { useLucaSignUp } from '../hooks/useLucaSignUp'
import * as Yup from 'yup'
import { useSwiper } from 'swiper/react'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const step3ValidationSchema = Yup.object({
  userType: Yup.string().required('Selecciona un tipo de usuario')
})

/**
 *
 * @returns {JSX.Element} The rendered component.
 */

export function StepForm3() {
  const addAccountProfileValues = useLucaSignUp(state => state.setAccountProfile)
  const accountProfile = useLucaSignUp(state => state.accountProfile)
  const swiper = useSwiper()

  const step3Values = {
    userType: accountProfile?.userType ?? ''
  }

  const handleNext = (values, actions) => {
    addAccountProfileValues(values)
    swiper.slideNext()
    actions.setSubmitting(true)
  }

  return (
    <Formik
      validationSchema={step3ValidationSchema}
      initialValues={step3Values}
      onSubmit={handleNext}
    >
      {({ setFieldValue, values }) => (
        <Form className='relative px-2 sm:px-1 pt-4'>
          <div className='relative'>
            <h3 className='mb-4 text-xl sm:text-2xl font-bold text-center'>
              ¿Qué tipo de rol te define mejor?
            </h3>
            <p className='text-center font-sans text-sm'>
              Selecciona el rol que mejor se ajuste a ti.
            </p>
          </div>
          <div className="grid gap-4 mt-6">
            <button
              type="button"
              onClick={() => setFieldValue('userType','contador')}
              className={`p-4 rounded-full border transition
                ${values.userType === "contador"
                  ? "border-primary bg-primary/10"
                  : "border-gray-200 hover:border-primary/40"}
              `}
            >
              <div className="font-semibold">Contador</div>
              <div className="text-sm text-gray-500">
                Manejas varias empresas
              </div>
            </button>

            <button
              type="button"
              onClick={() => setFieldValue('userType','empresa')}
              className={`p-4 rounded-full border transition
                ${values.userType === "empresa"
                  ? "border-primary bg-primary/10"
                  : "border-gray-200 hover:border-primary/40"}
              `}
            >
              <div className="font-semibold">Socio / Empresa</div>
              <div className="text-sm text-gray-500">
                Administras tu propia empresa
              </div>
            </button>
          </div>
          {/* Botones de navegación más abajo */}
          <div className='flex flex-col gap-2 mt-12 w-full sm:w-2/3 mx-auto'>
            <div className='flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8'>
              <button
                onClick={() => swiper.slidePrev()}
                type='button'
                className='btn-light-alt rounded-xl w-full sm:w-auto'
              >
                <FontAwesomeIcon className="" size='lg' icon={faArrowLeft} />
                <span>Volver</span>
              </button>
              <button type='submit' className='btn-primary rounded-xl w-full sm:w-auto'>
                <span>Continuar</span>
                <FontAwesomeIcon className="" size='lg' icon={faArrowRight} />
              </button>
            </div>
          </div>
          <br />
        </Form>
      )}
    </Formik>
  )
}